function run(file) {
  alert('test');
}
